import { memo } from 'react';
import Icon from '@/components/atoms/Icon';

function UnavailableOverlay() {
  return (
    <div
      id="clip-vision-analysis-failed-overlay"
      className="absolute inset-0 flex flex-col items-center justify-center rounded-md bg-gray-200 px-1"
    >
      <Icon name="IconAlertTriangle" size={20} />
      <div className="mt-3 font-medium">Clip might be briefly unavailable for this layout</div>
      <div className="mt-1 text-center text-xs text-slate-700">
        Please wait or switch to a different layout or template
      </div>
    </div>
  );
}

export default memo(UnavailableOverlay);
